import { create } from './create.js'
import { update } from './update'
import { getList } from './list'
import { getDetails } from './details'
import { close } from './close'
import flags from './flags'
import { getCurrencyList } from './currencyList.js'

export default {
  getList,
  create,
  update,
  getDetails,
  close,
  flags,
  getCurrencyList,
}
